const Loader = () => {
  return (
    <div className="loader-context">
      <i className="fa fa-spinner fa-spin"></i>
    </div>
  );
};

export default Loader;
